import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCollectionJarSpottedMushroomsFull extends Item {
    constructor() {
        super(definitions.ITEM_ID.COLLECTION_JAR_BLACK_SPOTTED_MUSHROOMS_FULL, texture("prop_jar_of_black_spotted_mushrooms_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}